<ng-container *ngIf="flightParams$ | async as flightPair">
  <div class="grid-col-12 grid-max-width no-row-gap padding-left-gutter padding-right-gutter center">
    <h1 class="nordic-blue-900-text col-1-12 ms-medium-y ms-xxlarge-b" *ngIf="heading$ | async">
      {{ heading$ | async }}
    </h1>
  </div>

  <cms-full-width-booking-widget
    [locations]="bookingWidgetLocations$ | async"
    [backgroundImage]="picture$ | async"
    [enableAward]="true"
    [enableAurinkomatkat]="false"
    [enablePromoCode]="true"
  >
  </cms-full-width-booking-widget>

  <div class="grid-col-12 grid-max-width no-row-gap padding-left-gutter padding-right-gutter center">
    <fin-ond-marketing-offers
      class="section-two-thirds-right col-1-12 md-col-2-11 ms-large-b"
      [originLocationCode$]="flightParams$ | finMap: 'origin'"
      [destinationLocationCode$]="flightParams$ | finMap: 'destination'"
      [links$]="links$"
    >
    </fin-ond-marketing-offers>

    <fin-block-image
      *ngIf="(picture$ | async) && (defaultCountryImage$ | async) !== null"
      class="section-two-thirds-right col-1-12 md-col-2-11 ms-large-y ond-marketing-image"
      [aspectRatio]="'16x9'"
      [imageData]="picture$ | async"
    >
    </fin-block-image>
    <div *ngIf="description" class="col-1-12 md-col-2-11">
      <article class="ond-marketing-description" [innerHTML]="description"></article>
    </div>

    <fin-ond-marketing-offers-list
      class="section-two-thirds-right col-1-12 md-col-2-11 ms-large-b"
      [originLocationCode$]="flightParams$ | finMap: 'origin'"
      [destinationLocationCode$]="flightParams$ | finMap: 'destination'"
      [links$]="links$"
    >
    </fin-ond-marketing-offers-list>

    <fin-ond-marketing-cross-linking
      *ngIf="url$ | async"
      class="section-two-thirds-right col-1-12 md-col-2-11 ms-large-b"
      [route]="url$ | async"
      [links$]="links$"
      [ondPageType]="ondPageType"
    >
    </fin-ond-marketing-cross-linking>

    <fin-ond-marketing-ribbon class="nordic-blue-50-bg col-1-12 sm-col-1-12 md-col-1-12"></fin-ond-marketing-ribbon>
  </div>
</ng-container>
